import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

const REQUEST_KEY = "requests";
const METADATA_KEY = "metadata";
const STATS_KEY = "stats";

export const prayerRequestsKeys = createKeys(
  featureKeys.PRAYER_REQUESTS_FEATURE_KEY,
  {
    prayerRequests: () => [REQUEST_KEY],
    metadata: () => [METADATA_KEY],
    stats: () => [STATS_KEY],
  }
);
